<template>
    <div class="my-2 p-2 rounded-lg bg-white wrapper">
        <p class="mb-2">ข้อมูลสินค้า COD</p>

        <div class="mb-4">
            <p class="mb-0 text-danger text-sm">เงื่อนไข</p>
            <p class="mb-0 text-danger text-sm">1. กรุณากรอกข้อมูลให้ครบทุกช่อง หากกรอกข้อมูลไม่ครบถ้วน จะไม่สามารถสร้างรายการได้</p>
            <p class="mb-0 text-danger text-sm">2. หากกรอกข้อมูลผิดพลาดหรือไม่ครบถ้วน ทางบริษัทจะยึดตามข้อมูลที่อยู่ในระบบ และไม่สามารถเคลมพัสดุกับขนส่งได้</p>
        </div>

        <div>
            <div :key="index" v-for="(item, index) in items" class="container-fluid">
                <div v-if="index === 0" class="row">
                    <div style="width: 30px;"></div>
                    <div class="pl-2 pr-2 col-2">
                        <p class="text-sm text-center">ชื่อสินค้า <span class="text-danger">*</span></p>
                    </div>
                    <div class="pl-0 pr-2 col-3">
                        <p class="text-sm text-center">ประเภท <span class="text-danger">*</span></p>
                    </div>
                    <div class="pl-0 pr-2 col-1">
                        <p class="text-sm text-center">ราคา <span class="text-danger">*</span></p>
                    </div>
                    <div class="pl-0 pr-2 col-1">
                        <p class="text-sm text-center">ขนาด</p>
                    </div>
                    <div class="pl-0 pr-2 col-2">
                        <p class="text-sm text-center">สี</p>
                    </div>
                    <div class="pl-0 pr-2 col-1">
                        <p class="text-sm text-center">น้ำหนัก (กรัม) <span class="text-danger">*</span></p>
                    </div>
                    <div class="pl-0 pr-2 col-1">
                        <p class="text-sm text-center">จำนวน <span class="text-danger">*</span></p>
                    </div>
                    <div style="width: 30px;"></div>
                </div>

                <div class="row">
                    <div class="d-flex justify-content-center mt-3" style="width: 30px;">
                         <svg 
                             xmlns="http://www.w3.org/2000/svg" 
                             width="16" height="16" 
                             viewBox="0 0 32 32"
                             :style="index !== items.length - 1 ? 'opacity: 0%; cursor: auto;' : 'opacity: 100%; cursor: pointer'"
                             @click="add"
                         >
                             <path fill="currentColor" d="M16 2A14.173 14.173 0 0 0 2 16a14.173 14.173 0 0 0 14 14a14.173 14.173 0 0 0 14-14A14.173 14.173 0 0 0 16 2m8 15h-7v7h-2v-7H8v-2h7V8h2v7h7Z"/><path fill="none" d="M24 17h-7v7h-2v-7H8v-2h7V8h2v7h7z"/>
                         </svg>
                    </div>
                    <div class="pl-2 pr-2 col-2 form-group">
                         <input class="form-control" :class="{ 'is-invalid': error && error[index] && error[index].name }" v-model="item.name" @input="update(index, 'name', item.name)" />
                         <small v-if="error && error[index] && error[index].name" class="text-danger">
                            {{error[index].name}}
                         </small>
                    </div>
                    <div class="pl-0 pr-2 col-3 form-group">
                         <AutoCompleteProduct 
                            :data="item.category"
                            :items="categoryExample"
                            :index="index"
                            field="category"
                            :isError="error && error[index] && error[index].category"
                            @input="handleInput"
                            @select:item="handleSelect"
                         />
                         <small v-if="error && error[index] && error[index].category" class="text-danger">
                            {{error[index].category}}
                         </small>
                    </div>
                    <div class="pl-0 pr-2 col-1 form-group">
                         <input class="form-control" :class="{ 'is-invalid': error && error[index] && error[index].price }" type="number" v-model="item.price" @input="update(index, 'price', Number(item.price))" />
                         <small v-if="error && error[index] && error[index].price" class="text-danger">
                            {{error[index].price}}
                         </small>
                    </div>
                    <div class="pl-0 pr-2 col-1 form-group">
                         <AutoCompleteProduct 
                            :data="item.size"
                            :items="sizeExample"
                            :index="index"
                            field="size"
                            :isError="error && error[index] && error[index].size"
                            @input="handleInput"
                            @select:item="handleSelect"
                         />
                    </div>
                    <div class="pl-0 pr-2 col-2 form-group">
                         <AutoCompleteProduct 
                            :data="item.color"
                            :items="colorExample"
                            :index="index"
                            field="color"
                            :isError="error && error[index] && error[index].color"
                            @input="handleInput"
                            @select:item="handleSelect"
                         />
                    </div>
                    <div class="pl-0 pr-2 col-1 form-group">
                         <input class="form-control" :class="{ 'is-invalid': error && error[index] && error[index].weight }" type="number" v-model="item.weight" @input="update(index, 'weight', Number(item.weight))" />
                         <small v-if="error && error[index] && error[index].weight" class="text-danger">
                            {{error[index].weight}}
                         </small>
                    </div>
                    <div class="pl-0 pr-2 col-1 form-group">
                         <input class="form-control" :class="{ 'is-invalid': error && error[index] && error[index].amount }" type="number" v-model="item.amount" @input="update(index, 'amount', Number(item.amount))" />
                         <small v-if="error && error[index] && error[index].amount" class="text-danger">
                            {{error[index].amount}}
                         </small>
                    </div>
                    <div class="d-flex justify-content-center mt-3" style="width: 30px;">
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            width="16" 
                            height="16" 
                            viewBox="0 0 256 256"
                            :style="items.length === 1 ? 'opacity: 0%; cursor: auto;' : 'opacity: 100%; cursor: pointer;'"
                            @click="remove(index)"
                        >
                            <path fill="currentColor" d="M216 48h-40v-8a24 24 0 0 0-24-24h-48a24 24 0 0 0-24 24v8H40a8 8 0 0 0 0 16h8v144a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V64h8a8 8 0 0 0 0-16M112 168a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0Zm48 0a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0Zm0-120H96v-8a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8Z"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import parcelType from '@/config/parcelType'
import AutoCompleteProduct from '@/components/custom/pos/cod/AutoCompleteProduct'

export default {
    name: 'CodProductList',
    props: {
        list: Array,
        courier: Object,
        error: Object
    },
    components: {
        AutoCompleteProduct
    },
    data() {
        let categories = parcelType;
        let initItems = [...this.list]

        if (this.courier) {
            if (['FLE', 'FLEB', 'FLEWP'].includes(this.courier.key)) {
                categories = parcelType.filter((t) => {return t.key != 'FRUIT'});
            } else if (this.courier.key == 'FLEF') {
                categories = [{key: 'FRUIT' , name: 'ผลไม้'}];
            }
        }

        if (initItems.length === 0) {
            initItems = [
                {
                    name: null,
                    category: null,
                    price: null,
                    size: null,
                    color: null,
                    weight: null,
                    amount: null
                }
            ]
        }

        return {
            items: initItems,
            parcelType: categories,
            categoryExample: [
                "เอกสาร",
                "อาหารแห้ง",
                "ของใช้",
                "อุปกรณ์ไอที",
                "เสื้อผ้า",
                "สื่อบันเทิง",
                "อะไหล่รถยนต์",
                "รองเท้า/กระเป๋า",
                "อุปกรณ์กีฬา",
                "เครื่องสำอางค์",
                "เฟอร์นิเจอร์",
                "ผลไม้",
                "อื่นๆ"
            ],
            sizeExample: [
                'XS',
                'S',
                'M',
                'L',
                'XL',
                '2XL',
                'ใหญ่',
                'เล็ก',
            ],
            colorExample: [
                'ขาว',
                'ดำ',
                'แดง',
                'เหลือง',
                'น้ำเงิน',
                'เขียว',
                'ม่วง',
                'ฟ้า',
                'ชมพู'
            ],
        }
    },
    watch: {
        list: {
            handler(newList) {
                if (newList.length > 0) {
                    this.items =  [...newList]
                }
            },
            deep: true
        }
    },
    methods: {
        add() {
            this.items.push(
                {
                    name: null,
                    category: null,
                    price: null,
                    size: null,
                    color: null,
                    weight: null,
                    amount: null
                }
            )
        },
        remove(index) {
            const filtered = this.items.filter((_, i) => i !== index)

            this.items = filtered
            this.$emit('onChangeCodProduct', [...this.items])
        },
        update(index, field, value) {
            if (Object.keys(this.error).length > 0 && this.error[index][field]) {
                this.error[index][field] = null
            }
            
            this.items[index][field] = value
            this.$emit('onChangeCodProduct', [...this.items])
        },
        handleInput(index, field, value) {
            this.update(index, field, value)
        },
        handleSelect(index, field, value) {
            this.update(index, field, value)
        }
    },
}
</script>

<style>
    .wrapper {
        border: 1px solid rgba(0, 0, 0, 0.1);
    }
    .list-item {
        display: grid;
        grid-template-columns: 30px repeat(7, 1fr) 30px;
    }
    input {
        min-width: 0 !important;
    }
    input[type="number"] {
        -moz-appearance: textfield; /* For Firefox */
    }

    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none; /* For Chrome, Safari, Edge, and Opera */
        margin: 0;
    }
</style>